import {
  type Dispatch,
  type SetStateAction,
  useCallback,
  useState,
} from 'react';

import { LocalAlertConfig } from '../../types/localeAlerts.ts';

type OpenChangeHandler = (open: boolean) => void;

type UseModalAlertsResult = {
  alerts: LocalAlertConfig[];
  setAlerts: Dispatch<SetStateAction<LocalAlertConfig[]>>;
  clearAlerts: () => void;
  removeAlert: (id: string) => void;
  handleOpenChange: (open: boolean, onOpenChange?: OpenChangeHandler) => void;
};

const useModalAlerts = (): UseModalAlertsResult => {
  const [alerts, setAlerts] = useState<LocalAlertConfig[]>([]);

  const clearAlerts = useCallback(() => {
    setAlerts([]);
  }, []);

  const removeAlert = useCallback((id: string) => {
    setAlerts((prevAlerts) => prevAlerts.filter((alert) => alert.id !== id));
  }, []);

  const handleOpenChange = useCallback(
    (open: boolean, onOpenChange?: OpenChangeHandler) => {
      if (!open) {
        clearAlerts();
      }

      onOpenChange?.(open);
    },
    [clearAlerts],
  );

  return {
    alerts,
    setAlerts,
    clearAlerts,
    removeAlert,
    handleOpenChange,
  };
};

export default useModalAlerts;
